import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export const searchSellerSales = async (q = '', range = '') => {
    const params = {};
    if (q) params.q = q;
    if (range) params.range = range;
    const { data } = await axios.get(`${API}/seller/sales`, { headers: authHeaders(), params });
    return data;
};

export const getSellerSaleDetail = async (saleId) => {
    const { data } = await axios.get(`${API}/seller/sales/${saleId}`, { headers: authHeaders() });
    return data;
};

export const resendSellerSaleMessage = async (saleId, { channel, type }) => {
    const { data } = await axios.post(
        `${API}/seller/sales/${saleId}/resend`,
        { channel, type },
        { headers: authHeaders() }
    );
    return data;
};

export const tempEditSaleCustomer = async (saleId, { name, email, phone }) => {
    const body = {};
    if (name != null) body.name = name;
    if (email != null) body.email = email;
    if (phone != null) body.phone = phone;
    const { data } = await axios.patch(
        `${API}/seller/sales/${saleId}/temp-edit-customer`,
        body,
        { headers: authHeaders() }
    );
    return data;
};

export const getMyEarnings = async () => {
    const { data } = await axios.get(`${API}/my-pending-sales`, { headers: authHeaders() });
    return data;
};
